var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"rounded-lg _safeAreaInsetContentMargin _box-shadow",staticStyle:{"hyphens":"auto","overflow-y":"auto"},attrs:{"id":"sheet","rounded":""}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }